
import { useEffect, useState } from "react";

import { useDispatch } from 'react-redux';

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { TipoCubiculoProps } from "../../interfaces/catalogos/TipoCubiculoInterface";

import { ActualizarTipoCubiculo, AgregarTipoCubiculo, TipoCubiculo } from "../../connections/catalogos/TipoCubiculoConnection";

export const TipoCubiculoPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [TipoCubiculoArray, setTipoCubiculoArray] = useState<TipoCubiculoProps[]>( [] );
 
    const [openModal, setOpenModal] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idTipoCubiculo, setIdTipoCubiculo] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );
    const [numeroCubiculo, setNumeroCubiculo] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 5 );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const TipoCubiculoSelected = TipoCubiculoArray.find( ( elem ) => elem.idTipoCubiculo === id );

        if( TipoCubiculoSelected ){

            await ActualizarTipoCubiculo({ ...TipoCubiculoSelected, activo: checked }).then( resp => {
                
                if( resp.idTipoCubiculo ){

                    var newArray = TipoCubiculoArray.map( ( elem ) => {

                    if( elem.idTipoCubiculo === id ){
                        elem.activo = checked;
                    }
            
                        return elem;
                    });
            
                    setTipoCubiculoArray( newArray );
                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));     

                }    
    
            });
        }       

    }

    const handleGuardar = async () => {

        if( idTipoCubiculo !== 0 ){

            const TipoCubiculoSelected = TipoCubiculoArray.find( ( elem ) => elem.idTipoCubiculo === idTipoCubiculo );

            if( TipoCubiculoSelected ){

                setLoading( true );
    
                await ActualizarTipoCubiculo({ ...TipoCubiculoSelected, descripcion, numeroCubiculo}).then( resp => {
                    
                    if( resp.idTipoCubiculo ){

                        setTimeout(() => {
                            
                            var newArray = TipoCubiculoArray.map( ( elem ) => {
        
                                if( elem.idTipoCubiculo === idTipoCubiculo ){
                                    elem.descripcion = descripcion;
                                    elem.numeroCubiculo = numeroCubiculo;
                                }
                        
                                return elem;
                            });
                    
                            setTipoCubiculoArray( newArray );
                            setOpenModal( false );
                            setLoading( false );
                            
                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));     
                            
                        }, 700);
    
                    }    
        
                });
            }       
    

        }
        else {

            const TipoCubiculoAdd: TipoCubiculoProps = {
                idTipoCubiculo: 0,
                descripcion,
                numeroCubiculo,               
                activo: true,
            }

            setLoading( true );

            await AgregarTipoCubiculo( TipoCubiculoAdd ).then( resp => {
                    
                if( resp.idTipoCubiculo ){                
            
                    setTimeout(() => {
                        
                        setTipoCubiculoArray([ ...TipoCubiculoArray, resp ]);
                        setOpenModal( false );
                        setLoading( false );
                        
                        dispatch( openSnackbar({ message: 'Se agrego el tipo de cubículo correctamente', variant: 'success' }));     

                    }, 700);

                }    
    
            });

        }

    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setTipoCubiculoArray( [] );

            await TipoCubiculo().then( resp => {

                setTimeout(() => {
                    
                    setTipoCubiculoArray( resp );
                    setLoadingData( false );
                    
                }, 700);

            });

        }

        obtener();

    }, [ ])    

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de cubículo' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >  
                
                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    <Button color="secondary" startIcon={ <UndoIcon /> } sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }> 
                        Regresar
                    </Button> 

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button                     
                        variant="contained" 
                        sx={{ mt: 1 }} 
                        disabled={ loadingData }
                        onClick={ () => {
                            
                            setIdTipoCubiculo( 0 );
                            setDescripcion( '' );

                            setOpenModal( true );
                        }}
                    > 
                        Agregar
                    </Button> 

                </Grid>

            </Grid>
            
            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center'  }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'25%' }}> Descripción </TableCell>                
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'50%', textAlign: 'center' }}> Número de cubiculo </TableCell>                     
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ? 
                                    TipoCubiculoArray.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                : 
                                    TipoCubiculoArray
                            )
                            .map( ( { idTipoCubiculo, descripcion, numeroCubiculo, activo } ) => (

                                <TableRow key={ idTipoCubiculo} >
                                
                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center'  }}>
                                        { idTipoCubiculo }
                                    </TableCell>                                 

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>  

                                    <TableCell sx={{ textAlign: 'center' }}>
                                        { numeroCubiculo }
                                    </TableCell>     

                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idTipoCubiculo ) }
                                        />                                            
                      
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {

                                                    setIdTipoCubiculo( idTipoCubiculo );
                                                    setDescripcion( descripcion ); 
                                                    setNumeroCubiculo( numeroCubiculo );                                                  

                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  

                                    </TableCell>

                                </TableRow>

                            ))
                        }                    
            
                        { 
                            ( TipoCubiculoArray.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 53 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" fontWeight={'bold'}> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            TipoCubiculoArray.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> 
                                            Total de registros: { TipoCubiculoArray.length } 
                                        </Typography>
                                    </TableCell> 

                                    <TablePagination  
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ TipoCubiculoArray.length }                                        
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>
                        }

                    </TableFooter>
                    
                </Table>
                
            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
            
                <DialogContent>

                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Número de cubículo'}
                        variant="outlined"              
                        fullWidth
                        value={ numeroCubiculo }
                        onChange={ (e) => setNumeroCubiculo( e.target.value ) }
                    /> 
                       
                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción'}
                        variant="outlined"                           
                        multiline
                        rows={4}                                        
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                    /> 

                </DialogContent>

                <DialogActions>
                    <Button color="secondary" disabled={ loading } onClick={ () => setOpenModal( false ) }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}